import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type IndicatorSetWithId = {
  idIndicatorSet: number;
};

// Базовый тип для create/update операций наборов индикаторов
type IndicatorSetCreateUpdateData = IndicatorSetWithId & {
  idIndicator: number;
  locked: boolean;
  values: unknown;
};

// Типы для WebSocket сообщений компонента indicatorSets
type IndicatorSetsListMessage = WebSocketMessageWithFields<'indicator-set-list' | 'global-pair-indicator' | 'pair' | 'calc-info', {
  indicatorSets: unknown[];
}>;
type IndicatorSetListNotFoundMessage = WebSocketMessageEmpty<'indicator-set-list-not-found'>;
type IndicatorSetCreateMessage = WebSocketMessageWithFields<'indicator-set-create' | 'indicator-set-create-success', IndicatorSetCreateUpdateData>;
type IndicatorSetUpdateMessage = WebSocketMessageWithFields<'indicator-set-update' | 'indicator-set-update-success', IndicatorSetCreateUpdateData>;
type IndicatorSetDeleteMessage = WebSocketMessageWithFields<'indicator-set-delete' | 'indicator-set-delete-success', IndicatorSetWithId>;
type IndicatorSetLockMessage = WebSocketMessageWithFields<'indicator-set-lock' | 'indicator-set-lock-success', IndicatorSetWithId>;
type IndicatorSetUnlockMessage = WebSocketMessageWithFields<'indicator-set-unlock' | 'indicator-set-unlock-success', IndicatorSetWithId>;

// Объединенный тип для всех сообщений
type IndicatorSetsWebSocketMessage = 
  | IndicatorSetsListMessage 
  | IndicatorSetListNotFoundMessage 
  | IndicatorSetCreateMessage 
  | IndicatorSetUpdateMessage 
  | IndicatorSetDeleteMessage 
  | IndicatorSetLockMessage 
  | IndicatorSetUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataIndicatorSets',
},
  __name: 'indicatorSets',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID набора индикаторов
const handleWebSocketMessage = (data: IndicatorSetsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'indicator-set-list':
    case 'global-pair-indicator':
    case 'pair':
    case 'calc-info':
      store.dispatch('indicatorSets/wsSetIndicatorSets', { indicatorSets: data.indicatorSets });
      break;
    case 'indicator-set-list-not-found':
      store.dispatch('indicator/wsSetEmptyIndicator');
      break;
    case 'indicator-set-create':
    case 'indicator-set-create-success':
      store.dispatch('indicatorSets/wsIndicatorSetCreate', {
        idIndicatorSet: data.idIndicatorSet,
        idIndicator: data.idIndicator,
        locked: data.locked,
        values: data.values,
      });
      break;
    case 'indicator-set-update':
    case 'indicator-set-update-success':
      store.dispatch('indicatorSets/wsIndicatorSetUpdate', {
        idIndicatorSet: data.idIndicatorSet,
        idIndicator: data.idIndicator,
        locked: data.locked,
        values: data.values,
      });
      break;
    case 'indicator-set-delete':
    case 'indicator-set-delete-success':
      store.dispatch('indicatorSets/wsIndicatorSetDelete', {
        idIndicatorSet: data.idIndicatorSet,
      });
      break;
    case 'indicator-set-lock':
    case 'indicator-set-lock-success':
      store.dispatch('indicatorSets/wsIndicatorSetLock', {
        idIndicatorSet: data.idIndicatorSet,
      });
      break;

    case 'indicator-set-unlock':
    case 'indicator-set-unlock-success':
      store.dispatch('indicatorSets/wsIndicatorSetUnlock', {
        idIndicatorSet: data.idIndicatorSet,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})